import axios from "axios";

let shift = false
document.addEventListener('keypress', (e) => {
    shift = e.shiftKey;
});
document.addEventListener('keyup', (e) => {
    shift = false;
});

const forms = document.querySelectorAll('[data-mark-form]');
forms.forEach((form) => {
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (shift) {
            sendForms(
                Array.from(
                    form.closest('.m-k__row').querySelectorAll('[data-mark-form]')
                )
            );
        } else {
            sendForms([form]);
        }
    })
});

const inputs = document.querySelectorAll('[data-mark-form] input[type="number"]');
inputs.forEach((input) => {
    input.addEventListener('keyup', (e) => {
        if (e.key === 'Backspace' && e.shiftKey) {
            const forms = Array.from(input.closest('.m-k__row').querySelectorAll('[data-mark-form]'));
            forms.forEach((form) => {
                form.querySelectorAll('input[type="number"]').forEach((inputEl) => {
                    inputEl.value = '';
                })
            });
        }
    })
});

function toggleClassForm(form, className) {
    form.classList.add(className);
    setTimeout(() => {
        form.classList.remove(className);
    }, 1000);
}

function sendForms(forms) {
    let promises = [];
    forms.forEach((form) => {
        const formData = new FormData(form);
        form.classList.add('_pending');
        promises.push(axios({
            url: '/marketplace/admin/markups/set/value',
            method: 'post',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        }).then(response => {

        }).catch(response => {
            toggleClassForm(form, '_error');
        }))
    });
    Promise.all(promises).then(() => {
        forms.forEach((form) => {
            form.classList.remove('_pending');
            toggleClassForm(form, '_success');
        })
    });
}

const searchInputLegacy = document.querySelector('[data-mm-search]');
if (searchInputLegacy) {
    searchInputLegacy.addEventListener('input', () => {
        processSearchLegacy(searchInputLegacy.value);
    });
}
const searchInput = document.querySelector('[data-mk-search]');
if (searchInput) {
    searchInput.addEventListener('input', () => {
        processSearch(searchInput.value);
    });
}

function processSearch(query) {
    // Разбиваем на группы, затем матчим те, для кого подошла хотя бы одна группа
    // Обходим офферы. Те кто поматчились маркируем _matched. Кто нет - убираем _matched

    const list = document.querySelector('[data-mk-list]');
    if (query) {
        list.classList.add('_search');
    } else {
        list.classList.remove('_search');
    }

    list.querySelectorAll('[data-offer]').forEach((offerEl) => {
        const name = offerEl.dataset.offerFullname;
        if (match(query, name)) {
            offerEl.classList.add('_matched');
        } else {
            offerEl.classList.remove('_matched');
        }
    });
}

function processSearchLegacy(query) {
    // Разбиваем на группы, затем матчим те, для кого подошла хотя бы одна группа
    // Обходим офферы. Те кто поматчились маркируем _matched. Кто нет - убираем _matched

    const list = document.querySelector('[data-mm-list]');
    if (query) {
        list.classList.add('_search');
    } else {
        list.classList.remove('_search');
    }

    list.querySelectorAll('[data-offer]').forEach((offerEl) => {
        const name = offerEl.dataset.offerFullname;
        if (match(query, name)) {
            offerEl.classList.add('_matched');
        } else {
            offerEl.classList.remove('_matched');
        }
    });
}

function match(query, string) {
    const queryMatch = string.toLowerCase();
    const groups = query.split('|');
    for (let key in groups) {
        const group = groups[key];
        const terms = group.trim().toLowerCase().split(/[ ,]+/);
        const filteredTerms = terms.filter((term) => !!term);
        if (filteredTerms.length < 1) {
            continue;
        }
        if (filteredTerms.every((term) => queryMatch.includes(term))) {
            return true;
        }
    }
    return false;
}

document.querySelectorAll('[data-toggle-markup]').forEach((markupEl) => {
    markupEl.addEventListener('click', (e) => {
        if (e.target.closest('[data-modal]')) {
            return;
        }
        if (e.target.closest('a')) {
            return;
        }

        e.preventDefault();
        markupEl.closest(markupEl.dataset.toggleMarkup).classList.toggle('_open');
    })
})